import { useState } from 'react'
import { XMarkIcon, EnvelopeIcon } from '@heroicons/react/24/outline'
import { apiClient } from '../../lib/api'
import { toast } from 'react-hot-toast'
import { useAuth } from '../../hooks/useAuth'

export default function ActivationBanner() {
  const { user } = useAuth()
  const [isVisible, setIsVisible] = useState(true)
  const [isResending, setIsResending] = useState(false)

  // Don't show banner if not visible, or if activation not required
  const isActivationRequired = apiClient.isActivationRequired()
  if (!isVisible || !isActivationRequired) {
    return null
  }

  const handleResend = async () => {
    if (!user?.email) {
      toast.error('Email address not found')
      return
    }

    try {
      setIsResending(true)
      await apiClient.resendActivation(user.email)
      toast.success('Activation email sent! Please check your inbox.')
    } catch (error: any) {
      toast.error(error.message || 'Failed to resend activation email')
    } finally {
      setIsResending(false)
    }
  }

  return (
    <div className="bg-yellow-50 border-b border-yellow-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center justify-between flex-wrap">
          <div className="flex-1 flex items-center">
            <EnvelopeIcon className="w-5 h-5 text-yellow-600 flex-shrink-0" />
            <p className="ml-3 text-sm text-yellow-800">
              <span className="font-medium">Please verify your email address.</span>
              {' '}Check your inbox for the activation link.
            </p>
          </div>
          <div className="flex items-center space-x-3">
            <button
              onClick={handleResend}
              disabled={isResending}
              className="text-sm font-medium text-yellow-800 hover:text-yellow-900 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isResending ? 'Sending...' : 'Resend email'}
            </button>
            <button
              onClick={() => setIsVisible(false)}
              className="text-yellow-600 hover:text-yellow-900"
            >
              <XMarkIcon className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
